module.exports = __webpack_public_path__ + "media/images/pc/specials/common/plan_yoso-41627adf25459983d8b384cb251cba19.jpg";